import type { NavigationItem } from "../types/navigation";

export const navigationItems: NavigationItem[] = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: "dashboard",
    path: "",
    isDisabled: true,
  },
  {
    id: "my-contracts",
    label: "Contracts",
    icon: "file-stack",
    path: "/my-contracts",
    requiredCapability: "contracts",
  },
  {
    id: "my-rfps",
    label: "My RFP's",
    icon: "clipboard-list",
    path: "/my-rfps",
    requiredCapability: "rfp",
  },
  {
    id: "prizelogic",
    label: "PrizeLogic",
    icon: "trophy",
    path: "/prizelogic",
    requiredCapability: "prize_rules",
  },
  {
    id: "library",
    label: "Library",
    icon: "grid",
    path: "/library",
    exact: true,
    requireLibrarySurface: true,
  },
  {
    id: "legal-entity",
    label: "Legal Entity",
    icon: "building",
    path: "/legal-entity",
    alwaysForAuthenticated: true,
  },
  {
    id: "representative-details",
    label: "Representative Details",
    icon: "representative-details",
    path: "/representative-details",
    alwaysForAuthenticated: true,
  },
  {
    id: "user-management",
    label: "User Management",
    icon: "users",
    path: "/user",
    requireSuperAdmin: true,
  },
];
